import ExportButton from '@/components/Chart/ExportButton';
import { useAppCsvExport } from '@/components/Chart/hooks/useAppCsvExport';

const ExportCsvButton = ({
  tabName,
  disabled = false
}: {
  tabName: string;
  disabled?: boolean;
}) => {
  const { handleExport, exportDisabled } = useAppCsvExport(tabName, disabled);

  return (
    <ExportButton
      disabled={exportDisabled}
      handleClick={handleExport}
      title='Download as CSV'
    />
  );
};

export default ExportCsvButton;
